import type { TongHopPhatSinhTheoDoiTuongItem } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

type TongHopPhatSinhTheoDoiTuongResponse =
  | {
      count?: number;
      next?: string | null;
      results?: TongHopPhatSinhTheoDoiTuongItem[];
    }
  | TongHopPhatSinhTheoDoiTuongItem[];

export const fetchAllTongHopPhatSinhTheoDoiTuong = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<TongHopPhatSinhTheoDoiTuongItem[]> => {
  let page = 1;
  let all: TongHopPhatSinhTheoDoiTuongItem[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.post<TongHopPhatSinhTheoDoiTuongResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.TONG_HOP_PHAT_SINH_THEO_DOI_TUONG}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const data = Array.isArray(response.data) ? response.data : response.data.results || [];
    totalCount = (Array.isArray(response.data) ? totalCount : response.data.count) ?? totalCount;
    all = all.concat(data);

    if (!data.length) {
      break;
    }

    const hasNext = !Array.isArray(response.data) && (response.data as any).next;

    if (!hasNext && data.length < pageSize) {
      break;
    }

    if (totalCount && all.length >= totalCount) {
      break;
    }

    page += 1;
  }

  return all;
};
